.selection-overlay {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1000;
}